export const APP_ID = 11;

export const SERVER_BASE_URL = "https://wwin.com:8080/";
//export const SERVER_BASE_URL = "https://testnisite.com:8105/";
export const INITIAL_SET_PARTITIONED_SUFFIX =
  "BetRadarDataService/InitialSetPartitioned";
export const THIRD_SET_PARTITIONED_SUFFIX =
  "BetRadarDataService/ThirdSetPartitioned";

export const LOCALHOST_BASE_URL = "http://localhost:1112/";

//ticket handler
export const TICKET_HANDLER_SUBMIT_COMBO_TICKET_SUFFIX =
  "TicketHandler?op=SubmitComboTicket";
export const TICKET_HANDLER_SUBMIT_SYSTEM_TICKET_SUFFIX =
  "TicketHandler?op=SubmitSystemTicket";
export const TICKET_HANDLER_SELECT_TICKET_SUFFIX =
  "TicketHandler?op=SelectTicket";
export const TICKET_HANDLER_SELECT_TICKET_PAIRS_SUFFIX =
  "TicketHandler?op=SelectTicketPairs";
export const TICKET_HANDLER_MAKE_TICKET_WINNING_SUFFIX =
  "TicketHandler?op=MakeTicketWinning";
export const TICKET_HANDLER_MAKE_TICKET_LOSING_SUFFIX =
  "TicketHandler?op=MakeTicketLosing";
export const TICKET_HANDLER_AUTHORIZE = "TicketHandler?op=Authorize";
export const TICKET_HANDLER_PAYOUT_TO_USER_SESSION =
  "TicketHandler?op=PayoutToUserSession";

//other services handler
export const OTHER_HANDLER_UPDATE_SESSION_BALANCE =
  "OtherRequestHandler?op=UpdateSessionBalance";
export const OTHER_HANDLER_LOGIN_BY_USERNAME_PASSWORD =
  "OtherRequestHandler?op=LoginUserByUsernamePassword";
export const OTHER_HANDLER_LOGIN_BY_USER_TOKEN =
  "OtherRequestHandler?op=LoginUserByToken";

//admin handler
export const ADMIN_HANDLER_GET_DASHBOARD_STATS =
  "AdminHandler?op=GetDashboardStats";
export const ADMIN_HANDLER_SELECT_BALANCE_INFO =
  "AdminHandler?op=GetTerminalBalanceInfo";
export const ADMIN_HANDLER_SELECT_TICKETS = "AdminHandler?op=GetBetHistory";
export const ADMIN_HANDLER_SELECT_BILL_FLOW = "AdminHandler?op=GetBillFlow";
export const ADMIN_HANDLER_SELECT_TRANSACTIONS =
  "AdminHandler?op=GetTransactions";
export const ADMIN_HANDLER_EXTRAS_CLEAR_DB = "AdminHandler?op=ExtrasClearDB";
export const ADMIN_HANDLER_RESET_PAPER_LENGTH =
  "AdminHandler?op=ResetPaperLength";
export const ADMIN_GET_PARTIAL_PAYOUT_RECEIPTS =
  "AdminHandler?op=GetPartialPayoutReceipts";
export const ADMIN_GET_EVENT_LOG = "AdminHandler?op=GetEventLog";

//partial payout handler
export const PARTIAL_PAYOUT_HANDLER_INSERT_NEW =
  "PartialPayoutHandler?op=InsertNewPartialPayout";
export const PARTIAL_PAYOUT_HANDLER_SELECT =
  "PartialPayoutHandler?op=SelectPartialPayout";
export const PARTIAL_PAYOUT_HANDLER_PAYOUT_TO_USER_SESSION =
  "PartialPayoutHandler?op=PayoutToUserSession";

//prematch info handler
export const PREMATCH_INFO_HANDLER_GET_CALENDAR_ITEMS =
  "PrematchInfoHandler?op=GetCalendarItems";
export const PREMATCH_INFO_HANDLER_GET_SPORT_TOURNAMENT_ITEMS =
  "PrematchInfoHandler?op=GetSportTournamentItems";
export const PREMATCH_INFO_HANDLER_GET_ACTIVE_PAIR_ITEMS =
  "PrematchInfoHandler?op=GetActivePairItems";
export const PREMATCH_INFO_HANDLER_GET_TIP_NAMES_FOR_MAIN_BETS =
  "PrematchInfoHandler?op=GetTipNamesForMainBets";
export const PREMATCH_INFO_HANDLER_GET_MOST_TIPPED_PAIRS =
  "PrematchInfoHandler?op=GetMostTippedPairs";
export const PREMATCH_INFO_HANDLER_GET_MOST_TIPPED_SPORTS =
  "PrematchInfoHandler?op=GetMostTippedSports";
export const PREMATCH_INFO_HANDLER_GET_SUPER_TIP_PAIRS =
  "PrematchInfoHandler?op=GetSuperTipPairs";
export const PREMATCH_INFO_HANDLER_GET_FAVORIT_PLUS_PAIRS =
  "PrematchInfoHandler?op=GetFavoritPlusPairs";
export const PREMATCH_INFO_HANDLER_GET_TOP_LEAGUES =
  "PrematchInfoHandler?op=GetTopLeagues";
export const PREMATCH_INFO_HANDLER_GET_MAIN_BETS =
  "PrematchInfoHandler?op=GetMainBets";
export const PREMATCH_INFO_HANDLER_GET_PAIRS_FOR_BET_TYPE =
  "PrematchInfoHandler?op=GetPairsForBetType";
export const PREMATCH_INFO_HANDLER_GET_PAIR_DETAILS =
  "PrematchInfoHandler?op=GetPairDetails";
export const PREMATCH_INFO_HANDLER_GET_PAIR_DETAILS_FOR_TICKET =
  "PrematchInfoHandler?op=GetPairDetailsForTicket";
export const PREMATCH_INFO_HANDLER_GET_ADDITIONAL_BET_NAMES_FOR_PAIR =
  "PrematchInfoHandler?op=GetAdditionalBetNamesForPair";
export const PREMATCH_INFO_HANDLER_GET_ADDITIONAL_BET_ODDS_FOR_PAIR =
  "PrematchInfoHandler?op=GetAdditionalBetOddsForPair";
export const PREMATCH_INFO_HANDLER_GET_BET_DETAILS =
  "PrematchInfoHandler?op=GetBetDetails";
export const PREMATCH_INFO_HANDLER_GET_TICKET_PAIRS =
  "PrematchInfoHandler?op=GetTicketPairs";



// WEBPACK FOOTER //
// ./src/Communication/Preferences.js